// src/hooks/useOnlineStatus.ts

import { useState, useCallback } from 'react';

export function useOnlineStatus() {
  const [onlineUsers, setOnlineUsers] = useState<Set<number>>(new Set());

  const handleOnlineEvent = useCallback((userId: number, online: boolean) => {
    setOnlineUsers((prev) => {
      const next = new Set(prev);
      if (online) {
        next.add(userId);
      } else {
        next.delete(userId);
      }
      return next;
    });
  }, []);

  const isOnline = useCallback(
    (userId: number): boolean => onlineUsers.has(userId),
    [onlineUsers]
  );

  return { onlineUsers, handleOnlineEvent, isOnline };
}
